'use client'

import React from 'react'
import { Modal, Drawer } from '@mantine/core'
import { useBreakpoint } from '@/hooks/useBreakpoints'

interface GMDrawerModalProps {
    opened: boolean
    onClose: () => void
    children: React.ReactNode
    size?: string | number
    withCloseButton?: boolean
    title?: React.ReactNode
    drawerSize?: string | number
    drawerRadius?: string | number
    modalRadius?: string
    withOverlay?: boolean
}

export default function GMDrawerModal({
    opened,
    onClose,
    children,
    size = 'md',
    withCloseButton = false,
    title,
    drawerSize = 'md',
    drawerRadius,
    modalRadius = 'lg',
    withOverlay = false,
}: GMDrawerModalProps) {
    const { isSm } = useBreakpoint()

    const preventClick = (event: React.SyntheticEvent) => {
        event.preventDefault()
        event.stopPropagation()
    }

    const clickProps = { onClick: preventClick }
    const closeButtonProps = { ...clickProps, 'aria-label': 'Close' }

    const overlayStyle = withOverlay
        ? {
              background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.50) 100%), rgba(8, 8, 71, 0.90)',
          }
        : undefined

    if (isSm) {
        return (
            <Drawer
                opened={opened}
                onClose={onClose}
                zIndex={2000}
                position="bottom"
                size={drawerSize}
                withCloseButton={withCloseButton}
                title={title}
                closeButtonProps={closeButtonProps}
                overlayProps={clickProps}
                styles={{
                    body: {
                        backgroundColor: 'var(--gm-cream-0)',
                    },
                    ...(drawerRadius !== undefined && {
                        content: {
                            borderTopLeftRadius: drawerRadius,
                            borderTopRightRadius: drawerRadius,
                            overflowX: 'hidden',
                            overflowY: 'auto',
                        },
                    }),
                    ...(overlayStyle && { overlay: overlayStyle }),
                }}
            >
                {children}
            </Drawer>
        )
    }

    return (
        <Modal
            opened={opened}
            onClose={onClose}
            zIndex={2000}
            centered
            withCloseButton={withCloseButton}
            size={size}
            radius={modalRadius}
            title={title}
            closeButtonProps={closeButtonProps}
            overlayProps={clickProps}
            styles={{
                body: {
                    backgroundColor: 'var(--gm-cream-0)',
                },
                ...(overlayStyle && { overlay: overlayStyle }),
            }}
        >
            {children}
        </Modal>
    )
}
